import { state } from '../context/store'

export const calculatePrice = (snap) => {
  const basePrice =
    snap.prices.basePrice[snap.initialChoices.threeDModel] ?? null

  if (!basePrice) return null


  let total = basePrice
  
  if (snap.choices.sidePanels.selected.mode === 'reinforced') {
    total += snap.prices.addonPrice.reinforcedSides
  }

  // if (snap.choices.foam.selected.mode === 'foam') {
    //   total += snap.prices.addonPrice.foam
    // }
    
    if (snap.choices.raceNumber.selected.mode === 'number') {
      total += snap.prices.addonPrice.number
    }
   
    
    if (snap.choices.sealant.selected.mode === 'sealant') {
      total += snap.prices.addonPrice.sealant
    }

    // if (snap.choices.superBadge?.selected?.mode === 'badge') {
    //   total += snap.prices.addonPrice.badge
    // }
 
    
    if (snap.choices.ribs.selected.mode !== 'no') {
      total += snap.prices.addonPrice.ribs
    }


  return total
}

export default calculatePrice;